import confetti from 'canvas-confetti';
import { toast } from 'sonner';

const defaultOptions: confetti.Options = {
  particleCount: 80,
  spread: 70,
  origin: { y: 0.65 },
  colors: ['#3b82f6', '#8b5cf6', '#06b6d4', '#10b981', '#f59e0b'],
};

/**
 * Fire a success confetti burst. Optionally show a toast message (e.g. for milestones).
 */
export function fireSuccessConfetti(options?: { message?: string }) {
  confetti({
    ...defaultOptions,
    particleCount: options?.message ? 100 : 80,
  });
  // Second burst from the left
  setTimeout(
    () =>
      confetti({
        ...defaultOptions,
        particleCount: 50,
        angle: 60,
        origin: { x: 0.2, y: 0.7 },
      }),
    150
  );
  // Third burst from the right
  setTimeout(
    () =>
      confetti({
        ...defaultOptions,
        particleCount: 50,
        angle: 120,
        origin: { x: 0.8, y: 0.7 },
      }),
    250
  );
  if (options?.message) {
    toast.success(options.message, { duration: 4000 });
  }
}
